import React, { useState, useEffect, useRef, useCallback } from 'react';
import Dropdown from '../../../Components/CustomDropdown/customdropdown';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import AddressAutocomplete from '../../../Components/addressInput/address-input';
import { updateFormData } from '../../../Redux/store/onboardingFormSlice';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../../Utils/toastContext';
import { debounce } from 'lodash';
import CustomDropdownWithFetch from '../../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import DocumentPreview from '../../Create-Investment/documentpreview';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
const BusinessInfo = ({ setCurrentStep }) => {
  const userStatus = useSelector((state) => state.user.userStatus);
  const stepStatus = useSelector((state) => state.form.stepStatus);
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [loading, setLoading] = useState(false);
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const [isValidAbn, setIsValidAbn] = useState(false);

  const [citizenType, setcitizenType] = useState({
    verification_id: null,
    value: {
      id: 1,
      name: 'Australian',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessName, setBusinessName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [abn, setAbn] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessAddress, setBusinessAddress] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const [nonResCountryText, setNonResCountryText] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [businessNature, setBusinessNature] = useState({
    verification_id: null,
    value: {
      id: null,
      name: '',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [taxId, setTaxId] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const fieldLabelMap = {
    tax_resident_country: 'Tax Resident Country',
    country_id: 'Country',
    business_registration_number: 'Business Registration Number',
    tax_id: 'Tax ID',
    abn: 'ABN',
    business_name: 'Business Name',
    business_activity: 'Describe the business activity',
    other_business_activity: 'Please mention business activity',
    source_of_funds: 'Source of the funds including its origin',
    purpose_of_opening_account: 'Purpose of opening account',
    documents: 'Supporting document',
    address_id: 'Address of Principal Place of Business',
    nature_n_level_of_intended_transactions:
      'Nature and level of the intended transaction behaviour',
    beneficial_ownership_with_caprock:
      'Beneficial ownership of the funds used by this account',
  };
  const [activity, setActivity] = useState({
    verification_id: null,
    value: {
      id: null,
      name: '',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [otherActivity, setOtherActivity] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [source, setSource] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [transactionLevel, setTransactionLevel] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [ownership, setOwnership] = useState({
    verification_id: null,
    value: true,
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [businessRegNumber, setBusinessRegNumber] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [socialSecurityNumber, setSocialSecurityNumber] = useState('');
  const [apIAddress, setApIAddress] = useState('');
  const [isConfirmReset, setIsConfirmReset] = useState(false);
  const { showToast } = useToast();
  const [accountPurpose, setAccountPurpose] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });

  const [redCountry, setRedCountry] = useState(null);
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [businessActivityData, setBusinessActivityData] = useState([]);
  const [businessNatureData, setBusinessNatureData] = useState([]);
  const [fileAttorneyPath, setfileAttorneyPath] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [fileAttorney, setFileAttorney] = useState(null);
  const [fileAvailable, setFileAvailable] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({});
  const [preselectedCitizenType, setpreselectedCitizenType] = useState({
    value: 1,
    label: 'Australian',
  });
  const [preselectedBusinessNature, setpreselectedBusinessNature] = useState(
    {},
  );
  const [preselectedBusinessActivity, setpreselectedBusinessActivity] =
    useState({});

  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: 'Australia',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [citizenTypedata, setCitizenTypedata] = useState([]);

  const handleDeleteFile = () => {
    setFileAttorney(null);
    setFileAvailable(false);
    setfileAttorneyPath({
      verification_id: null,
      value: '',
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const validateAbn = async () => {
    const cleanedAbn = abn.value?.replace(/\s+/g, '');

    if (!cleanedAbn || cleanedAbn.length !== 11) return;
    let toastMessage = null;
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/abn-lookup/${cleanedAbn}`,
      );
      if (response.status == 200) {
        setIsValidAbn(true);
      } else {
        toastMessage = { message: response.message, type: 'error' };
        setIsValidAbn(false);
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
      setIsValidAbn(false);
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/api/v1/files/upload`;
    const formData3 = new FormData();
    formData3.append('file', file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }
      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleFileChangeAttorney = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ['application/pdf', 'image/png', 'image/jpeg'].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileAttorney(selectedFile);
        setLoading(true);
        handleUploadFileAttorney(selectedFile);
      } else {
        showToast(
          'File must be PDF, PNG, or JPEG and less than 10MB.',
          'error',
        );
      }
    }
    e.target.value = '';
  };
  const handleUploadFileAttorney = useCallback(
    debounce(async (fileUploaded) => {
      let toastMessage = null;
      try {
        const response = await fileUploadNew(fileUploaded);
        if (response.status == 201) {
          setfileAttorneyPath({
            ...fileAttorneyPath,
            value: response.data,
          });
          setFileAvailable(true);
        } else {
          setFileAvailable(false);
          toastMessage = { message: response.message, type: 'error' };
        }
      } catch (err) {
        setFileAvailable(false);
        toastMessage = { message: err.message, type: 'error' };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [fileAttorney], // Dependencies
  );
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        businessAddress.value.country &&
          businessAddress.value.country.name &&
          businessAddress.value.country.name !== ''
          ? businessAddress.value.country.name
          : businessAddress.value.country,
        businessAddress.value.state &&
          businessAddress.value.state.name &&
          businessAddress.value.state.name !== ''
          ? businessAddress.value.state.name
          : businessAddress.value.state,
        businessAddress.value.city &&
          businessAddress.value.city.name &&
          businessAddress.value.city.name !== ''
          ? businessAddress.value.city.name
          : businessAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    if (
      (businessAddress.value && businessAddress.value.country) ||
      (businessAddress.value && businessAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [businessAddress]);
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getAllEnums = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/customer/business-information/enums`,
      );

      if (response.status == 200) {
        let AllAccount = [];
        response.data.business_activity_choices.forEach((profile, index) => {
          AllAccount.push({
            value: profile.value,
            label: profile.label,
          });
        });

        setBusinessActivityData(AllAccount);

        let AllAccount3 = [];
        response.data.tax_resident_country_choices.forEach((profile, index) => {
          AllAccount3.push({
            value: profile.value,
            label: profile.label,
          });
        });

        setCitizenTypedata(AllAccount3);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const handleContinue = (isFinal) => {
    if (isFinal) {
      if (!citizenType.value.name) {
        showToast('Please select tax resident country', 'error');
        return;
      }
      if (!businessAddress.value || !redCountry) {
        showToast('Please enter valid business address', 'error');
        return;
      }
      if (!businessName) {
        showToast('Please enter valid business name', 'error');
        return;
      }
      if (
        (citizenType.value.id == 1 && !abn.value) ||
        (abn.value && abn.value.length != 11) ||
        !isValidAbn
      ) {
        showToast('Please enter a valid 11 digits ABN', 'error');
        return;
      }
      if (!activity.value.id) {
        showToast('Please select business activity', 'error');
        return;
      }
      if (activity.value.id == 6 && !otherActivity.value) {
        showToast('Please enter other activity', 'error');
        return;
      }
      if (!accountPurpose) {
        showToast('Please enter the purpose of opening account', 'error');
        return;
      }
      if (citizenType.value.id == 2 && !countryCode.value.id) {
        showToast('Please select country', 'error');
        return;
      }
      if (!source) {
        showToast('Please enter source of the funds', 'error');
        return;
      }
      if (citizenType.value.id != 1 && !businessRegNumber.value) {
        showToast('Please enter business registration number', 'error');
        return;
      }
      if (!transactionLevel.value) {
        showToast(
          'Please enter Nature and level of the intended transaction behaviour',
          'error',
        );
        return;
      }
      if (citizenType.value.id == 3 && !taxId.value) {
        showToast('Please enter Tax ID', 'error');
        return;
      }
    }
    setLoading(true);
    handlesave(isFinal);
  };
  const handleSelectCitizenType = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setcitizenType({
      ...citizenType,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  const handleSelectBusinessNature = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setBusinessNature({
      ...businessNature,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };

  const handleSelectActivity = (selectedOption) => {
    console.log('Selected Option:', selectedOption.value);
    setActivity({
      ...activity,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
    setOtherActivity({
      verification_id: null,
      value: '',
      status: 'pending',
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/customer/business-information/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {
    setCurrentStep(1);
  };
  const safeValue = (val) =>
    val === undefined || val === null || val === '' ? null : val;

  const safeId = (val) => {
    if (val === null || val === undefined || val === '') return null;

    // if already primitive
    if (typeof val === 'number' || typeof val === 'string') {
      return val;
    }

    // dropdown patterns
    return val?.id ?? val?.value?.id ?? val?.value ?? null;
  };

  const safeFile = (file) => {
    const f = file?.value ?? file;

    if (!f?.file_id || !f?.file_name) return null;

    return {
      file_id: f.file_id,
      file_name: f.file_name,
    };
  };

  const safeArray = (arr) => (Array.isArray(arr) ? arr : []);

  const buildDocuments = () => {
    const file = safeFile(fileAttorneyPath);

    if (!file) return [];

    return [file];
  };
  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == 'onboarding' ? true : false;

    let apiUrl = isOnbaording
      ? `${BASE_URL}/api/v1/onboarding/customer/business-information/submit`
      : `${BASE_URL}/api/v1/onboarding/customer/business-information/update`;

    let bodyData = {};
    const basePayload = {
      tax_resident_country: safeId(citizenType?.value),
      business_name: safeValue(businessName?.value),
      abn: safeValue(abn?.value),

      address: payloadAddress ?? null,

      // 🔥 FIXED (always ID only)
      business_activity: safeId(activity?.value),

      other_business_activity: safeValue(otherActivity?.value),

      purpose_of_opening_account: safeValue(accountPurpose?.value),

      country_id: safeId(countryCode?.value),

      source_of_funds: safeValue(source?.value),

      business_registration_number: safeValue(businessRegNumber?.value),

      nature_n_level_of_intended_transactions: safeValue(
        transactionLevel?.value,
      ),

      beneficial_ownership_with_caprock: safeValue(ownership?.value),

      is_submitted: Boolean(isFinal),
    };
    if (citizenType?.value?.id == 1) {
      bodyData = {
        ...basePayload,

        documents: buildDocuments(),
      };
    }
    if (citizenType?.value?.id == 2) {
      bodyData = {
        ...basePayload,

        documents: buildDocuments(),
      };
    }
    if (citizenType?.value?.id == 3) {
      bodyData = {
        ...basePayload,

        country_id: 233,

        tax_id: safeValue(taxId?.value),

        documents: buildDocuments(),
      };
    }
    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log('Selected Option:', selectedOption);
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
      },
    });
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (apIAddress != null) {
        payloadAddress = {
          address_line_1:
            apIAddress.address_line_1 == null
              ? apIAddress.google_address
              : apIAddress.address_line_1,
          address_line_2:
            apIAddress.address_line_2 == null
              ? null
              : apIAddress.address_line_2,
          city_id: apIAddress.city != null ? apIAddress.city.id : null,
          state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
          country_id: redCountry,
          zip_code: apIAddress.postal_code,
          google_address: apIAddress.google_address,
        };
      } else {
        if (businessAddress.value) {
          payloadAddress = {
            address_line_1:
              businessAddress.value.street == ''
                ? businessAddress.value.full
                : businessAddress.value.street,
            address_line_2: businessAddress.value.route,
            city_id: redCity,
            state_id: redState,
            country_id: redCountry,
            zip_code: businessAddress.value.zip,
            google_address: businessAddress.value.full,
          };
        }
      }
      // if (payloadAddress.city_id === null) {
      //   showToast("Please select a valid city before proceeding.", "error");
      //   return; // Stop execution if city_id is missing
      // }
      const response = await submitApplicationAPI(isFinal, payloadAddress);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(3);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/api/v1/users/countries?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const handleOwnership = (e) => {
    const value = e.target.value === 'true'; // convert string → boolean
    setOwnership({
      ...ownership,
      value: value,
    });
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/customer/business-information/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          setcitizenType(response.data.tax_resident_country);
          setpreselectedCitizenType({
            value: response.data.tax_resident_country.value.id,
            label: response.data.tax_resident_country.value.name,
          });
          if (response.data.tax_resident_country.value.id == 2) {
            setCountryCode(response.data.country);
            setpreselectedCountryCode({
              value: response.data.country.value.id,
              label: response.data.country.value.name,
            });
          }
          setApIAddress(response.data.address.value);
          setBusinessAddress(response.data.address);
          setBusinessName(response.data.business_name);
          setAbn(response.data.abn);
          if (response.data.abn.value) {
            setIsValidAbn(true);
          }
          setBusinessRegNumber(response.data.business_registration_number);
          setActivity(response.data.business_activity);
          setpreselectedBusinessActivity({
            value: response.data.business_activity.value.id,
            label: response.data.business_activity.value.name,
          });
          setOtherActivity(response.data.other_business_activity);
          setSource(response.data.source_of_funds);
          setAccountPurpose(response.data.purpose_of_opening_account);
          setfileAttorneyPath({
            verification_id: response.data.documents.verification_id,
            value: response.data.documents.value[0],
            status: response.data.documents.status,
            rejection_reason: response.data.documents.rejection_reason,
            rejection_comment: response.data.documents.rejection_comment,
            rejection_timestamp: response.data.documents.rejection_timestamp,
            rejected_by: response.data.documents.rejected_by,
            comments: response.data.documents.comments,
          });
          setTransactionLevel(
            response.data.nature_n_level_of_intended_transactions,
          );
          setTaxId(response.data.tax_id);
          /* FIX: hydrate whichever key the preview API returns. */
          setOwnership(
            response.data.beneficial_ownership_with_caprock ??
              response.data.beneficial_ownership_with_ratified,
          );
        } else {
          setcitizenType({
            verification_id: null,
            value: {
              id: 1,
              name: 'Australian',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCitizenType({
            value: 1,
            label: 'Australian',
          });
          setCountryCode({
            verification_id: null,
            value: {
              id: 14,
              name: 'Australia',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({});

          setApIAddress('');
          setBusinessAddress({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setBusinessName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAbn({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });

          setBusinessNature({
            verification_id: null,
            value: {
              id: null,
              name: '',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedBusinessNature({});
          setBusinessRegNumber({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setActivity({
            verification_id: null,
            value: {
              id: null,
              name: '',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedBusinessActivity({});
          setOtherActivity({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setSource({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setAccountPurpose({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setfileAttorneyPath({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });

          setTransactionLevel({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setTaxId({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setOwnership({
            verification_id: null,
            value: true,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getAllCountries();
    getAllEnums();
  }, []);
  useEffect(() => {
    /* FIX: businessNatureData is never populated by getAllEnums, so the
       old `businessNatureData.length > 0` condition was always false and
       the verification preview never loaded — statuses, comment counts
       and rejection borders never appeared for any field. */
    if (stepStatus.length > 1 && stepStatus[1].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      updateFieldStatus &&
      stepStatus.length > 1 &&
      stepStatus[1].status != 'DRAFT'
    ) {
      getDetailsWithVerification();
    }
  }, [updateFieldStatus, stepStatus]);

  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] w-full max-w-full min-w-0 overflow-x-hidden">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999] p-4">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'IN_REVIEW' ||
            stepStatus[1].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}
        {stepStatus.length > 0 && stepStatus[1].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}

        {rejectedFields?.BUSINESS_INFORMATION?.rejected_fields?.length > 0 && (
          <div className="mb-4 rounded-2xl border border-rose-200 bg-rose-50 p-4">
            <p className="mb-2 text-sm font-bold text-rose-700">
              {rejectedFields.BUSINESS_INFORMATION.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.BUSINESS_INFORMATION.rejected_fields.map(
                (field) => (
                  <span
                    key={field}
                    className="rounded-full bg-rose-100 px-3 py-1 text-xs font-semibold text-rose-700"
                  >
                    {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                  </span>
                ),
              )}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4 mb-4">
          <div className=" border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2">
              <img
                src="/buildings.svg"
                alt="User Avatar"
                className="h-6 w-6 mb-2"
              />
              <h1 className="text-xl font-medium mb-2">Business Information</h1>
            </div>
            <li className="text-xs ml-2 font-medium text-[#FF5050]">
              If you need to adjust any information from the previous section,
              please click on the “Reset Application” button
            </li>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-6">
            <div className="flex flex-col px-4 pt-4 border-r-0 lg:border-r border-gray-300">
              <div className="mb-2">
                <LabelWithStatus
                  id="citizenType"
                  label={fieldLabelMap.tax_resident_country}
                  required={true}
                  fieldData={citizenType}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  options={citizenTypedata}
                  onSelect={handleSelectCitizenType}
                  preselectedValue={preselectedCitizenType}
                  parentClass={
                    citizenType.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  }
                />
              </div>
              {citizenType.value.id == 2 && (
                <>
                  <div className="mt-2">
                    <LabelWithStatus
                      id="citizenTypeCountry"
                      label={fieldLabelMap.country_id}
                      required={true}
                      fieldData={countryCode}
                      handleStatusClick={handleStatusClick}
                    />
                    <CustomDropdownWithFetch
                      label=""
                      options={countryCodeData}
                      search={true}
                      preselectedValue={preselectedCountryCode}
                      onSelect={handleSelectCountryCode}
                      colorLabel=""
                      parentClass={
                        countryCode.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      }
                      fetchOptions={getCountries} // <-- pass fetch function, not options
                    />
                  </div>
                </>
              )}
              {(citizenType.value.id == 2 || citizenType.value.id == 3) && (
                <>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="businessRegistrationNumber"
                      label={fieldLabelMap.business_registration_number}
                      required={true}
                      fieldData={businessRegNumber}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="businessRegNumber"
                      name="businessRegNumber"
                      type="text"
                      value={businessRegNumber.value}
                      placeholder="Enter Number"
                      disabled={
                        businessRegNumber.status == 'approved' ? true : false
                      }
                      className={`${
                        businessRegNumber.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setBusinessRegNumber({
                          ...businessRegNumber,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                </>
              )}
              {citizenType.value.id == 3 && (
                <div className="mt-4">
                  <LabelWithStatus
                    id="taxID"
                    label={fieldLabelMap.tax_id}
                    required={true}
                    fieldData={taxId}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="taxID"
                    name="taxID"
                    type="text"
                    value={taxId.value}
                    placeholder="Enter Number"
                    disabled={taxId.status == 'approved' ? true : false}
                    className={`${
                      taxId.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setTaxId({
                        ...taxId,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
              )}
              {citizenType.value.id == 1 && (
                <div className="mt-4">
                  <LabelWithStatus
                    id="companyLogo"
                    label={fieldLabelMap.abn}
                    required={true}
                    fieldData={abn}
                    handleStatusClick={handleStatusClick}
                  />
                  <div
                    className={`${
                      abn.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    }  flex items-center border px-2 rounded-lg w-full`}
                  >
                    <input
                      id="abn"
                      name="abn"
                      type="text"
                      value={abn.value}
                      placeholder="Enter ABN"
                      disabled={abn.status == 'approved'}
                      onBlur={validateAbn}
                      className={` h-[2.813rem] dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none  w-full leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) => {
                        setAbn({
                          ...abn,
                          value: e.target.value,
                        });
                        setIsValidAbn(false);
                      }}
                    />
                    {isValidAbn != null && (
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300 ${
                          isValidAbn
                            ? 'text-green-500 scale-110'
                            : 'text-red-500 scale-110'
                        }`}
                      >
                        {isValidAbn ? 'check_circle' : 'cancel'}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className="flex lg:pt-4 pt-0 flex-col px-4 md:pl-0 pr-4 border-r-0 lg:border-r border-gray-300">
              <div className="">
                <LabelWithStatus
                  id="businessName"
                  label={fieldLabelMap.business_name}
                  required={true}
                  fieldData={businessName}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="businessName"
                  name="businessName"
                  type="text"
                  value={businessName.value}
                  placeholder="Business Name"
                  disabled={businessName.status == 'approved' ? true : false}
                  className={`${
                    businessName.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setBusinessName({
                      ...businessName,
                      value: e.target.value,
                    })
                  }
                />
              </div>

              <div className="mt-4">
                <LabelWithStatus
                  id="activityType"
                  label={fieldLabelMap.business_activity}
                  required={true}
                  fieldData={activity}
                  handleStatusClick={handleStatusClick}
                />
                <Dropdown
                  label=""
                  preselectedValue={preselectedBusinessActivity}
                  options={businessActivityData}
                  onSelect={handleSelectActivity}
                  disabled={activity.status == 'approved' ? true : false}
                  parentClass={
                    activity.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  }
                />
                {activity.value.id == 6 && (
                  <div className="mt-4">
                    <LabelWithStatus
                      id="others"
                      label={fieldLabelMap.other_business_activity}
                      required={true}
                      fieldData={otherActivity}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="others"
                      name="others"
                      type="text"
                      value={otherActivity.value}
                      disabled={
                        otherActivity.status == 'approved' ? true : false
                      }
                      placeholder="Other activity"
                      className={`${
                        otherActivity.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setOtherActivity({
                          ...otherActivity,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                )}
                <div className="mt-4">
                  <LabelWithStatus
                    id="source"
                    label={fieldLabelMap.source_of_funds}
                    required={true}
                    fieldData={source}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="source"
                    name="source"
                    type="text"
                    value={source.value}
                    placeholder="Enter Source"
                    disabled={source.status == 'approved' ? true : false}
                    className={`${
                      source.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setSource({
                        ...source,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <LabelWithStatus
                    id="accountPurpose"
                    label={fieldLabelMap.purpose_of_opening_account}
                    required={true}
                    fieldData={accountPurpose}
                    handleStatusClick={handleStatusClick}
                  />
                  <input
                    id="accountPurpose"
                    name="accountPurpose"
                    type="text"
                    value={accountPurpose.value}
                    placeholder="Enter purpose"
                    className={`${
                      accountPurpose.status == 'rejected'
                        ? 'border-[#FF5050] border-2'
                        : ''
                    } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                    onChange={(e) =>
                      setAccountPurpose({
                        ...accountPurpose,
                        value: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="mt-4">
                  <div className="flex items-center justify-between">
                    <LabelWithStatus
                      id="fileUpload"
                      label={fieldLabelMap.documents}
                      required={false}
                      fieldData={fileAttorneyPath}
                      handleStatusClick={handleStatusClick}
                    />
                  </div>
                  {/* Drag & Drop Upload Area */}
                  <label
                    className={`${
                      fileAttorneyPath.status == 'rejected'
                        ? 'border-[#FF5050]'
                        : ''
                    } border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center`}
                  >
                    <input
                      type="file"
                      id="fileUpload"
                      accept=".pdf,.png,.jpeg"
                      onChange={handleFileChangeAttorney}
                      disabled={
                        fileAttorneyPath.status == 'approved' ? true : false
                      }
                      className="hidden"
                    />
                    <img
                      src="/folder-add.svg"
                      alt="Success Icon"
                      className="h-4 w-4"
                    />{' '}
                    <p
                      disabled={
                        fileAttorneyPath.status == 'approved' ? true : false
                      }
                      className="mt-2 text-gray-500 text-sm"
                    >
                      Drag & Drop <br />
                      or <span className="underline">Click to Upload</span>
                    </p>
                  </label>
                  <div className="mt-1">
                    <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PNG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      JPEG
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      PDF
                    </span>
                    <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                      &#60; 10 MB
                    </span>
                  </div>

                  {fileAttorneyPath && fileAttorneyPath.value && (
                    <div
                      className={`${
                        fileAttorneyPath.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border'
                      }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                    >
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          handleFileClick(e, fileAttorneyPath.value);
                        }}
                        className="flex-col flex"
                      >
                        <span className="text-black break-all underline cursor-pointer">
                          {fileAttorneyPath.value.file_name}
                        </span>
                        <span className="text-[#46DA55] text-xs">
                          Upload Completed
                        </span>
                      </div>
                      {fileAttorneyPath.status != 'approved' && (
                        <button
                          onClick={handleDeleteFile}
                          className="text-red-500 flex-shrink-0 font-semibold"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete Icon"
                            className="h-4 w-4 flex-shrink-0"
                          />
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={
                  currentDocument.presigned_url
                    ? currentDocument.presigned_url
                    : currentDocument.url
                }
                fileName={currentDocument.file_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            <div className="flex lg:pt-4 pt-0 flex-col px-4">
              <div className="">
                <div className="">
                  <LabelWithStatus
                    id="address"
                    label={fieldLabelMap.address_id}
                    required={true}
                    fieldData={businessAddress}
                    handleStatusClick={handleStatusClick}
                  />
                  <AddressAutocomplete
                    value={
                      businessAddress?.value?.full ||
                      apIAddress?.google_address ||
                      ''
                    }
                    onSelect={(addr) => {
                      setApIAddress(null);
                      setBusinessAddress({
                        ...businessAddress,
                        value: addr,
                      });
                    }}
                    disabled={
                      businessAddress.status == 'approved' ? true : false
                    }
                    className={
                      businessAddress.status == 'rejected'
                        ? 'border-[#FF5050] border-2 w-full'
                        : 'w-full'
                    }
                  />
                </div>
              </div>
              <div className="mt-6">
                <LabelWithStatus
                  id="transactionLevel"
                  label={fieldLabelMap.nature_n_level_of_intended_transactions}
                  required={true}
                  fieldData={transactionLevel}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  id="transactionLevel"
                  name="transactionLevel"
                  type="text"
                  value={transactionLevel.value}
                  placeholder="Enter transaction behaviour"
                  disabled={
                    transactionLevel.status == 'approved' ? true : false
                  }
                  className={`${
                    transactionLevel.status == 'rejected'
                      ? 'border-[#FF5050] border-2'
                      : ''
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                  onChange={(e) =>
                    setTransactionLevel({
                      ...transactionLevel,
                      value: e.target.value,
                    })
                  }
                />
              </div>
              <div className="mt-4">
                <LabelWithStatus
                  id="ownership"
                  label={fieldLabelMap.beneficial_ownership_with_caprock}
                  required={true}
                  fieldData={ownership}
                  handleStatusClick={handleStatusClick}
                />
                <div
                  className={`flex items-center gap-4 ${
                    ownership.status == 'rejected'
                      ? 'border-[#FF5050] border-2 rounded-lg px-3 py-2'
                      : ''
                  }`}
                >
                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="ownership"
                      value={true}
                      checked={ownership.value === true}
                      disabled={ownership.status == 'approved' ? true : false}
                      onChange={handleOwnership}
                      className={`${
                        ownership.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border-gray-300'
                      } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                    />
                    <span className="">Yes</span>
                  </label>

                  <label className="flex items-center text-sm text-black">
                    <input
                      type="radio"
                      name="ownership"
                      value={false}
                      disabled={ownership.status == 'approved' ? true : false}
                      checked={ownership.value === false}
                      onChange={handleOwnership}
                      className={`${
                        ownership.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border-gray-300'
                      } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                    />
                    <span className="">No</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      <footer className="mt-4 flex flex-col flex-shrink-0 md:flex-row gap-3 md:gap-4 p-3 sm:p-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] sm:pb-4 bg-[#375AE7] sticky bottom-0 z-20 md:static w-full">
        {stepStatus.length > 0 &&
          stepStatus[1].status != 'COMPLETED' &&
          stepStatus[1].status != 'APPROVED' &&
          stepStatus[1].status != 'IN_REVIEW' && (
            <>
              {' '}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-start w-full gap-2 sm:gap-3">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={true}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="bottom-actions flex flex-col sm:flex-row mt-0 items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4">
                <div className="w-full sm:w-auto flex justify-center sm:justify-end">
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>
                </div>
                <ConfirmContinueButton
                  onContinue={() => handleContinue(true)}
                  buttonText="Continue"
                  confirmTitle="Save Section"
                  confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                />
              </div>
            </>
          )}
        {stepStatus.length > 0 &&
          (stepStatus[1].status == 'COMPLETED' ||
            stepStatus[1].status == 'APPROVED' ||
            stepStatus[1].status == 'IN_REVIEW') && (
            <>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-start w-full gap-2 sm:gap-3">
                <ConfirmResetButton
                  onConfirm={handleReset}
                  isReset={false}
                  isBack={true}
                  onBack={handleBack}
                />
              </div>
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-end w-full gap-2 sm:gap-3 md:gap-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(3);
                  }}
                  className="flex w-full sm:w-auto min-h-[44px] items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            </>
          )}
      </footer>
    </div>
  );
};

export default BusinessInfo;
